import { SearchSelect } from './SearchSelect';
import { withSearchSelect } from './withSearchSelect';

const ConnectedSearchSelect = withSearchSelect(SearchSelect);

export { ConnectedSearchSelect as SearchSelect };
